const DESKTOP_MEDIA_QUERY = "(min-width: 550px)";

class BannerContent extends HTMLElement {

    constructor() {
        super();
        this.playVideo = true;
        this.desktopMediaQuery = null;
        this.handleViewportChange = this.handleViewportChange.bind(this);
    }

    disconnectedCallback() {
        this.desktopMediaQuery?.removeEventListener("change", this.handleViewportChange);
    }

    connectedCallback() {
        this.buttonPlay = this.querySelector(".button-play");
        this.buttonPlayIcon = this.querySelector(".icon-play");
        this.buttonPlayText = this.querySelector(".button-play--text");
        this.videos = this.querySelectorAll(".videoplayer");
        this.desktopVideos = this.querySelectorAll(".videoplayer.video-desktop");
        this.mobileVideos = this.querySelectorAll(".videoplayer.video-mobile");

        this.desktopMediaQuery = window.matchMedia(DESKTOP_MEDIA_QUERY);
        this.desktopMediaQuery.addEventListener("change", this.handleViewportChange);

        this.initPlayerButton();
        this.startVideo();
        this.checkFocus();
    }

    // Player-Button
    initPlayerButton() {
        if (!this.buttonPlay) {
            return; // Button existiert nicht, z.B. wenn kein Video vorhanden
        }

        this.buttonPlay.addEventListener("click", () => {
            if (this.playVideo) {
                this.stopVideo();
            } else {
                this.startVideo();
            }
        });
    }

    // Nur die zum aktuellen Viewport passenden Videos
    activeVideos() {
        return this.desktopMediaQuery.matches ? this.desktopVideos : this.mobileVideos;
    }

    inactiveVideos() {
        return this.desktopMediaQuery.matches ? this.mobileVideos : this.desktopVideos;
    }

    // Video stoppen
    stopVideo() {
        if (!this.buttonPlayIcon || !this.buttonPlayText) {
            return; // Button-Elemente existieren nicht
        }
        this.buttonPlayIcon.classList.remove("element-icon-pause"); // Icons tauschen
        this.buttonPlayIcon.classList.add("element-icon-play");
        this.buttonPlayText.innerText = "Video gestoppt. Klicken, um Video zu starten"; // Text ändern
        this.playVideo = false; // Status setzen
        this.videos.forEach(video => {
            video.pause();
        });
    }

    // Video starten
    startVideo() {
        if (!this.buttonPlayIcon || !this.buttonPlayText) {
            return; // Button-Elemente existieren nicht
        }
        this.buttonPlayIcon.classList.remove("element-icon-play"); // Icons tauschen
        this.buttonPlayIcon.classList.add("element-icon-pause");
        this.buttonPlayText.innerText = "Video gestartet. Klicken, um Video zu stoppen"; // Text ändern
        this.playVideo = true; // Status setzen
        // Nur das zum Viewport passende Video laden und abspielen
        this.inactiveVideos().forEach(video => video.pause());
        this.activeVideos().forEach(video => video.play());
    }

    // Viewport-Wechsel: nur fortsetzen, wenn nicht manuell gestoppt
    handleViewportChange() {
        if (this.playVideo) {
            this.startVideo();
        }
    }

    // Funktion zur Überprüfung des Tastaturfokus auf die Links in der Liste
    checkFocus() {
        const bannerItems = this.querySelectorAll('.inhalt a'); // Alle Links in der Liste
        bannerItems.forEach(link => {
            link.addEventListener('focus', () => {
                this.stopVideo();
            });
        });
    }

}

if (!customElements.get("banner-content")) {
    customElements.define("banner-content", BannerContent);
}
